import { dispatchData } from '../index';

const updateItsUninstalProtocol = (dispatch, data, task, updatedItsUninstalProtocol) => {
  const tasks = [...data.tasks];
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  tasks.splice(taskIndex, 1, {
    ...task,
    itsUninstalProtocol: updatedItsUninstalProtocol,
  });

  dispatchData(dispatch, data, tasks);
};

const handleDamageDescriptionChange = (event, dispatch, task, data) => {
  const updatedItsUninstalProtocol = { ...task.itsUninstalProtocol };
  updatedItsUninstalProtocol.damageDescription = event.target.value;

  updateItsUninstalProtocol(dispatch, data, task, updatedItsUninstalProtocol);
};

const toggleProtocolFields = (dispatch, data, task, itsUninstalProtocol) => {
  const updatedItsUninstalProtocol = { ...itsUninstalProtocol };
  updatedItsUninstalProtocol.open = !updatedItsUninstalProtocol.open;

  const updatedTask = {
    ...task,
    itsUninstalProtocol: updatedItsUninstalProtocol,
  };

  const updatedTasks = [...data.tasks];
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  updatedTasks.splice(taskIndex, 1, updatedTask);

  dispatchData(dispatch, data, updatedTasks);
};

const toggleDamageDescriptionField = (dispatch, task, data, showField) => {
  let itsUninstalProtocol = { ...task.itsUninstalProtocol };
  let updatedDamageDescriptionField = itsUninstalProtocol.damageDescriptionField;
  let updatedDamageDescription = itsUninstalProtocol.damageDescription;

  if (updatedDamageDescriptionField && updatedDamageDescriptionField === 'no' && showField) {
    updatedDamageDescriptionField = 'yes';
  } else if (
    updatedDamageDescriptionField &&
    updatedDamageDescriptionField === 'yes' &&
    !showField
  ) {
    updatedDamageDescriptionField = 'no';
    updatedDamageDescription = '';
  } else {
    return;
  }

  const updatedTask = {
    ...task,
    itsUninstalProtocol: {
      ...task.itsUninstalProtocol,
      damageDescriptionField: updatedDamageDescriptionField,
      damageDescription: updatedDamageDescription,
    },
  };

  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const updatedTasks = [...data.tasks];
  updatedTasks.splice(taskIndex, 1, updatedTask);

  dispatchData(dispatch, data, updatedTasks);
};

const validateUninstalProtocol = itsUninstalProtocol => {
  let messages = [];
  if (itsUninstalProtocol.damageDescriptionField === 'yes') {
    const errorTextForLessLenght =
      'Моля, опишете с повече от 3 символа нанесените щети при посещението в протокол за деинсталация!';
    const errorTextForMoreLength =
      'Описанието за нанесена щета при посещение в протокол за деинсталация не може да бъде над 2000 символа';
    messages.push(
      getMessageForField(
        itsUninstalProtocol.damageDescription,
        errorTextForLessLenght,
        errorTextForMoreLength
      )
    );
  }

  return messages;
};

const getMessageForField = (field, errorTextForLessLenght, errorTextForMoreLength) => {
  if (!field || field.length < 3) return errorTextForLessLenght;
  else if (!field && field.length > 2000) return errorTextForMoreLength;
};

export {
  validateUninstalProtocol,
  handleDamageDescriptionChange,
  toggleDamageDescriptionField,
  toggleProtocolFields,
};
